/**
 * Auto-add product to cart when subtotal (after discount) reaches threshold
 *
 * Configuration:
 * - Variant ID: 47511080337635 - Free Brush
 * - Threshold: $100 (10000 cents)
 * - Adds only once
 */

console.log("wohu.js loaded");

// Helper function to fetch cart data
const fetchCart = async () => {
  try {
    if (!Shopify || !Shopify.routes || !Shopify.routes.root) {
      console.error("wohu: Shopify.routes.root is not available");
      return null;
    }
    const url = `${Shopify.routes.root}cart.js`;
    console.log("wohu: Fetching cart from", url);
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const cart = await response.json();
    console.log("wohu: Cart fetched", {
      item_count: cart.item_count,
      total_price: cart.total_price,
      items: cart.items?.map(i => ({
        variant_id: i.variant_id,
        quantity: i.quantity,
      })),
    });
    return cart;
  } catch (error) {
    console.error("wohu: Error fetching cart:", error);
    return null;
  }
};

// Helper function to check if product is already in cart
const isProductInCart = (cart, variantId) => {
  if (!cart || !cart.items) return false;
  return cart.items.some(item => item.variant_id === parseInt(variantId));
};

const isProductInCartByProduct = (cart, productId) => {
   if (!cart || !cart.items) return false;
  return cart.items.some(item => item.product_id === parseInt(productId));
}

// Helper function to get cart drawer section ID
const getCartDrawerSectionId = () => {
  const cartDrawer = document.querySelector("hdt-cart-drawer");
  if (cartDrawer) {
    return cartDrawer.getAttribute("section-id");
  }
  return null;
};

// Helper function to add product to cart
const addProductToCart = async variantId => {
  try {
    if (!Shopify || !Shopify.routes || !Shopify.routes.root) {
      console.error("wohu: Shopify.routes.root is not available for add");
      return null;
    }

    // Get cart drawer section ID to include in request
    const sectionId = getCartDrawerSectionId();
    const sections = sectionId ? [sectionId] : [];

    const url = `${Shopify.routes.root}cart/add.js`;
    console.log("wohu: Adding product to cart", { variantId, url, sections });

    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/javascript",
      },
      body: JSON.stringify({
        items: [
          {
            id: parseInt(variantId),
            quantity: 1,
          },
        ],
        sections_url: window.location.pathname,
        sections: sections.join(","),
      }),
    });

    if (!response.ok) {
      const errorText = await response.text();
      console.error("wohu: Add to cart failed", {
        status: response.status,
        statusText: response.statusText,
        errorText,
      });
      throw new Error(`Failed to add product: ${response.statusText}`);
    }

    const result = await response.json();
    console.log("wohu: Add to cart response", result);
    return result;
  } catch (error) {
    console.error("wohu: Error adding product to cart:", error);
    return null;
  }
};

// Helper function to update cart drawer section HTML
const updateCartDrawerSection = async addResult => {
  //   console.log("wohu: Updating cart drawer section, addResult: ", addResult);
  //   Object.entries(addResult.sections).forEach(([key, value]) => {
  //     if (key.includes("section")) {
  //       const sectionId = key;
  //       const section = document.getElementById(`shopify-section-${sectionId}`);
  //       console.log("wohu: Section", section);
  //       if (section) {
  //         section.innerHTML = value;
  //       }
  //     }
  //   });
  //   console.log("wohu: Cart drawer section updated");
  document.dispatchEvent(new CustomEvent("cart:reload", { bubbles: true }));
};

// Helper function to trigger cart update/render
const triggerCartUpdate = async (cartData, addResult) => {
  console.log("wohu: Triggering cart update");
  // Update cart drawer section HTML if available
  if (addResult) {
    await updateCartDrawerSection(addResult);
  }
};

// Main function to check threshold and add product if needed
const checkAndAddProduct = async () => {
  console.log("wohu: checkAndAddProduct called");

  // Prevent multiple simultaneous checks
  if (window.wohuAutoAddInProgress) {
    console.log("wohu: Already in progress, skipping");
    return;
  }

  // Prevent checking immediately after we just added (to avoid loop from our own cart:change event)
  if (window.wohuJustAddedProduct) {
    console.log("wohu: Just added product, skipping re-check");
    window.wohuJustAddedProduct = false;
    return;
  }

  window.wohuAutoAddInProgress = true;

  try {
    // Fetch current cart
    const cart = await fetchCart();

    if (!cart) {
      console.log("wohu: No cart data, exiting");
      return;
    }

    // Configuration
    const REQUIRED_PRODUCT_ID = 8908455411939 // -> hair protector
    const VARIANT_ID = 47511080337635; // -> brush for free
    const THRESHOLD_CENTS = 10000; // $100

    console.log("wohu: Checking conditions", {
      total_price: cart.total_price,
      threshold: THRESHOLD_CENTS,
      meets_threshold: cart.total_price >= THRESHOLD_CENTS,
    });

    // Check if product is already in cart
    const alreadyInCart = isProductInCart(cart, VARIANT_ID);
    console.log("wohu: Product in cart?", alreadyInCart);

    if (alreadyInCart) {
      console.log("wohu: Product already in cart, no action needed");
      return; // Already added, no need to add again
    }

    const requiredItemInCart = isProductInCartByProduct(cart, REQUIRED_PRODUCT_ID)
    console.log("requiredItemInCart", requiredItemInCart)

    // Check if cart total (after discount) meets threshold
    // cart.total_price is already after discounts in cents
    // if (cart.total_price >= THRESHOLD_CENTS) {
    if (requiredItemInCart) {
      console.log("wohu: conditions met! Adding product...");
      // Add product to cart
      const addResult = await addProductToCart(VARIANT_ID);

      if (addResult) {
        console.log("wohu: Product added successfully");
        // Set flag to prevent immediate re-check
        window.wohuJustAddedProduct = true;

        // Fetch updated cart after adding
        const updatedCart = await fetchCart();

        if (updatedCart) {
          // Trigger cart update/render (pass addResult to update sections)
          await triggerCartUpdate(updatedCart, addResult);
        }
      } else {
        console.error("wohu: Failed to add product");
      }
    } else {
      console.log("wohu: conditions not met", {
        current: cart.total_price,
        needed: THRESHOLD_CENTS,
        remaining: THRESHOLD_CENTS - cart.total_price,
      });
    }
  } catch (error) {
    console.error("wohu: Error in checkAndAddProduct:", error);
  } finally {
    window.wohuAutoAddInProgress = false;
  }
};

// Initialize event listeners
const initAutoAddProduct = () => {
  console.log("wohu: Initializing event listeners");

  // Listen to cart update events
  document.addEventListener("cart:update", event => {
    console.log("wohu: cart:update event received", event);
    checkAndAddProduct();
  });

  // Listen to cart:change events (used by QuickOrderList)
  // Use a flag to prevent our own cart:change from triggering
  document.addEventListener("cart:change", event => {
    // Skip if this is our own event (has our marker)
    if (event.detail && event.detail.wohuSkip) {
      return;
    }
    console.log("wohu: cart:change event received", event);
    checkAndAddProduct();
  });

  // Listen to dialog open events (for cart drawer)
  document.addEventListener("dialog:open", event => {
    // Check if it's the cart drawer
    if (event.target && event.target.id === "CartDrawer") {
      console.log("wohu: Cart drawer opened");
      checkAndAddProduct();
    }
  });
};

// Initialize when script loads
initAutoAddProduct();
